export const terminalTheme= {
  terminal: {
    parts: ['root', 'heading', 'highlight'],
    baseStyle: {
      root: {
      
      },
      heading: {
     
      },
      animation: {
     
      },
      switch: {
     
      }
    }
  }
};
